<template>
  <div class="animated fadeIn profile-component">
    <vLoading v-if="vLoading" />
    <div v-if="pageLoaded">
      <div v-if="$router.currentRoute.path == '/university/dashboard'">
        <v-row>
          <v-col class="text-first">
            <v-btn
              href="https://api.biodcportal.com/setad/public/RFP%20فراخوان%20فناوری.pdf"
              class="bc-green btn-radius no-underline"
              height="45"
              elevation="0"
              target="_blank"
            >
              <span class="fs-medium white--text">
                <v-icon class="me-1">mdi-download</v-icon>
                دریافت RFP</span
              >
            </v-btn>
          </v-col>
          <v-col class="text-end">
            <v-btn
              :to="'/university/preview'"
              class="bc-purple btn-radius no-underline"
              height="45"
              elevation="0"
              target="_blank"
            >
              <span class="fs-medium white--text">
                <v-icon class="me-1">mdi-eye-outline</v-icon>
                پیش‌نمایش</span
              >
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6" xl="6" class="pb-0">
            <v-card class="transparent-card card-height">
              <v-row class="h-100 mb-2">
                <v-col sm="6" cols="12" class="pb-0">
                  <v-card class="common-card card-height">
                    <v-row class="mt-1 mb-12">
                      <v-col class="pt-0 d-flex flex-row">
                        <h5 class="c-dark fs-xxlarge t-1">نام دانشگاه</h5>
                        <span @click="openNoEditDialog('name')">
                          <v-icon
                            class="c-purple pb-1 px-2 pointer"
                            style="
                              font-size: 1.7rem;
                              transform: translateY(-2px);
                            "
                            >mdi-alert-circle-outline</v-icon
                          >
                        </span>
                      </v-col>
                    </v-row>
                    <div class="card-height fs-xlarge pt-13 d-flex">
                      <img
                        v-if="uniInfo.isDistinguished"
                        class="star-icon me-2"
                        src="/icon-star.png"
                      />
                      <h5 class="mt-3 c-grey fs-xxlarge">
                        {{ uniInfo.name }}
                      </h5>
                    </div>
                  </v-card>
                </v-col>
                <v-col sm="6" cols="12" class="pb-0"
                  ><v-card class="common-card card-height">
                    <v-row>
                      <v-col>
                        <h5 class="mt-1 mb-3 c-dark fs-xxlarge">
                          لوگو دانشگاه
                        </h5>
                      </v-col>
                      <v-col cols="2" class="text-left">
                        <span @click="openEditModal('logo')" class="pointer">
                          <v-icon>$Edit</v-icon>
                        </span>
                      </v-col>
                    </v-row>
                    <div
                      @click="showBigModal = true"
                      class="logo-box pointer mt-9"
                    >
                      <img
                        :src="
                          uniInfo.avatar
                            ? uniInfo.avatar
                            : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                        "
                      />
                    </div> </v-card
                ></v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card card-height">
              <v-row class="mb-1">
                <v-col>
                  <h5 class="mt-1 c-dark fs-xxlarge">اطلاعات تماس دانشگاه</h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="openEditModal('contact')" class="pointer"
                    ><v-icon>$Edit</v-icon></span
                  >
                </v-col>
              </v-row>
              <div class="c-grey">
                <v-icon class="pe-2 ps-0">$Location</v-icon>
                <span class="fs-medium">
                  نشانی دانشگاه:
                  {{
                    uniInfo.state +
                    ", " +
                    uniInfo.city +
                    (uniInfo.city ? ", " : "")
                  }}
                  {{ uniInfo.address ? uniInfo.address : "--" }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="pe-2 ps-0">$Phone</v-icon>
                <span class="fs-medium">
                  تلفن‌های تماس روابط عمومی:
                  <span dir="ltr">{{ uniInfo.tel ? uniInfo.tel : "--" }}</span>
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="pe-2 ps-0">$Email</v-icon>
                <span class="fs-medium">
                  کدپستی: {{ uniInfo.postalCode ? uniInfo.postalCode : "--" }}
                </span>
              </div>
              <div class="pt-4 c-grey">
                <v-icon class="pe-2 ps-0">$Url</v-icon>
                <span class="fs-medium" v-if="uniInfo.website">
                  آدرس‌‌ تارنما:
                  <a :href="checkWebsite()" target="_blank">{{
                    uniInfo.website
                  }}</a>
                </span>
                <span class="fs-medium" v-else> آدرس‌‌ تارنما: -- </span>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card card-height">
              <v-row class="mb-4">
                <v-col>
                  <h5 class="mt-1 c-dark fs-xxlarge">توضیحات</h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="openEditModal('description')" class="pointer"
                    ><v-icon>$Edit</v-icon></span
                  >
                </v-col>
              </v-row>
              <div v-if="uniInfo.description">
                <div v-if="type != 'mobile'">
                  <p class="c-grey fs-medium mb-0 text-justify">
                    {{
                      uniInfo.description.length > 400
                        ? uniInfo.description.slice(0, 400) + "..."
                        : uniInfo.description
                    }}
                  </p>
                  <div
                    v-if="uniInfo.description.length > 400"
                    class="text-left pt-5"
                  >
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('description')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
                <div v-if="type == 'mobile'">
                  <p class="c-grey fs-medium mb-0 text-justify">
                    {{
                      uniInfo.description.length > 200
                        ? uniInfo.description.slice(0, 200) + "..."
                        : uniInfo.description
                    }}
                  </p>
                  <div
                    v-if="uniInfo.description.length > 200"
                    class="text-left pt-5"
                  >
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('description')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
              </div>
              <div class="mt-2" v-else>
                <hr />
                <p class="c-grey fs-small text-center">
                  توضیحی برای دانشگاه ثبت نشده است.
                </p>
                <hr />
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6" xl="6">
            <v-card class="common-card pb-10">
              <v-row class="">
                <v-col>
                  <!--<h5 class="mt-1 fs-xlarge">
                      تعداد دانشجویان و اعضای هیئت علمی
                    </h5>-->
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="openEditModal('students')" class="pointer"
                    ><v-icon>$Edit</v-icon></span
                  >
                </v-col>
              </v-row>
              <v-row class="mt-4">
                <v-col class="request-box border-left pb-0">
                  <div>
                    <v-row>
                      <v-col class="text-center">
                        <span class="fs-medium commonTextColor"
                          >تعداد دانشجویان مرتبط با زیست فناوری</span
                        >
                      </v-col>
                    </v-row>
                    <div
                      class="fs-large c-dark commonTextColor text-center pt-8"
                    >
                      {{
                        uniInfo.bioStudentCounts
                          ? uniInfo.bioStudentCounts
                          : "0"
                      }}
                      نفر
                    </div>
                  </div>
                </v-col>
                <v-col class="request-box pb-0">
                  <div>
                    <v-row>
                      <v-col class="text-center">
                        <span class="fs-medium commonTextColor"
                          >تعداد کل دانشجویان</span
                        >
                      </v-col>
                    </v-row>
                    <div
                      class="fs-large c-dark commonTextColor text-center pt-8"
                    >
                      {{ uniInfo.studentCounts ? uniInfo.studentCounts : "0" }}
                      نفر
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-8">
                <v-col class="border-top mx-8"></v-col>
                <v-col class="border-top mx-8"></v-col>
              </v-row>
              <v-row class="mb-1">
                <v-col class="request-box border-left pb-0">
                  <div>
                    <v-row>
                      <v-col class="text-center">
                        <span class="fs-medium commonTextColor"
                          >تعداد اعضای هیئت علمی مرتبط با زیست فناوری</span
                        >
                      </v-col>
                    </v-row>
                    <div
                      class="fs-large c-dark commonTextColor text-center pt-8"
                    >
                      {{
                        uniInfo.bioScienceCommitteeCounts
                          ? uniInfo.bioScienceCommitteeCounts
                          : "0"
                      }}
                      نفر
                    </div>
                  </div>
                </v-col>
                <v-col class="request-box pb-0">
                  <div>
                    <v-row>
                      <v-col class="text-center">
                        <span class="fs-medium commonTextColor"
                          >تعداد کل اعضای هیئت علمی</span
                        >
                      </v-col>
                    </v-row>
                    <div
                      class="fs-large c-dark commonTextColor text-center pt-8"
                    >
                      {{
                        uniInfo.scienceCommitteeCounts
                          ? uniInfo.scienceCommitteeCounts
                          : "0"
                      }}
                      نفر
                    </div>
                  </div>
                </v-col>
              </v-row>
              <!--<v-row class="pt-6">
                  <v-col>
                    <span class="fs-large">
                      {{
                        uniInfo.bioScienceCommitteeCounts
                          ? uniInfo.bioScienceCommitteeCounts
                          : "0"
                      }}
                      نفر
                    </span>
                  </v-col>
                </v-row>-->
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col lg="6" md="12" cols="12">
            <v-card class="common-card card-height">
              <v-row class="pe-2 ps-2">
                <v-col class="center-col">
                  <v-row>
                    <v-col>
                      <h5 class="fs-xxlarge">
                        اعضای هیئت علمی تعریف شده در سامانه
                      </h5>
                    </v-col>
                    <v-col cols="2" class="text-left">
                      <router-link to="/university/faculty">
                        <v-icon>$Edit</v-icon>
                      </router-link>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  uniInfo.scienceCommittee &&
                  uniInfo.scienceCommittee.length &&
                  type != 'mobile'
                "
              >
                <v-col
                  cols="4"
                  sm="4"
                  md="3"
                  lg="3"
                  xl="3"
                  v-for="(professor, index) in uniInfo.scienceCommittee.slice(
                    0,
                    4
                  )"
                  :key="index"
                  class="text-center"
                >
                  <img
                    class="professor-img w-100 mb-3"
                    :src="
                      professor.avatar
                        ? professor.avatar
                        : 'https://bigbangram.com/theme/img/noavatar.png'
                    "
                  />
                  <h6 class="fs-medium c-dark">{{ professor.name }}</h6>
                  <span class="c-grey fs-small">{{ professor.degree }}</span>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  uniInfo.scienceCommittee &&
                  uniInfo.scienceCommittee.length &&
                  type == 'mobile'
                "
              >
                <v-col
                  cols="4"
                  sm="4"
                  md="3"
                  lg="3"
                  xl="3"
                  v-for="(professor, index) in uniInfo.scienceCommittee.slice(
                    0,
                    3
                  )"
                  :key="index"
                  class="text-center"
                >
                  <img
                    class="professor-img w-100 mb-3"
                    :src="
                      professor.avatar
                        ? professor.avatar
                        : 'https://bigbangram.com/theme/img/noavatar.png'
                    "
                  />
                  <h6 class="fs-medium c-dark fs-large">
                    {{ professor.name }}
                  </h6>
                  <span class="c-grey fs-medium">{{ professor.degree }}</span>
                </v-col>
              </v-row>
              <div
                v-if="
                  !uniInfo.scienceCommittee || !uniInfo.scienceCommittee.length
                "
                class="my-8 c-grey fs-small text-center"
              >
                <hr />
                عضوی به ثبت نرسیده است.
                <hr />
              </div>
            </v-card>
          </v-col>
          <v-col lg="6" md="12" cols="12" class="stretch-col">
            <v-card class="common-card card-height">
              <v-row class="mb-2">
                <v-col class="center-col">
                  <h5 class="mb-4 fs-xxlarge">
                    <!-- {{ computedMehvarCardTitle }} -->
                    موضوعات طرح تقسیم کار ملی
                  </h5>
                  <span @click="openNoEditDialog('mehvar')">
                    <v-icon
                      class="c-purple pb-2 px-2 pointer"
                      style="font-size: 1.7rem; transform: translateY(-4px)"
                      >mdi-alert-circle-outline</v-icon
                    >
                  </span>
                  <v-spacer></v-spacer>
                  <h6 class="fs-large">
                    {{ uniInfo.cats.length + " مورد" }}
                  </h6>
                </v-col>
              </v-row>
              <div
                v-if="!uniInfo.cats.length"
                class="my-10 c-grey fs-small text-center"
              >
                <hr />
                موضوعی به ثبت نرسیده است.
                <hr />
              </div>
              <div v-else>
                <div>
                  <div
                    v-for="(cat, index) in uniInfo.cats"
                    :key="index"
                    class="mb-3"
                  >
                    <li class="fs-medium c-grey">
                      <v-icon>mdi-circle-medium</v-icon>
                      {{ cat.name }}
                    </li>
                  </div>
                </div>
              </div>
              <!-- <div
                v-if="
                  !uniInfo.mehvars.length &&
                  !uniInfo.otherMehvars.filter((x) => x.acceleratorId).length
                "
                class="my-10 c-grey fs-small text-center"
              >
                <hr />
                محوری به ثبت نرسیده است.
                <hr />
              </div>
              <div v-else>
                <div v-if="uniInfo.mehvars.length > 4">
                  <div
                    v-for="(mehvar, index) in uniInfo.mehvars.slice(0, 4)"
                    :key="index"
                    class="mb-3"
                  >
                    <li class="fs-medium c-grey">
                      <v-icon>mdi-circle-medium</v-icon>
                      {{
                        mehvar.name.length > 70
                          ? mehvar.name.slice(0, 70) + "..."
                          : mehvar.name
                      }}
                    </li>
                  </div>
                  <div class="text-left pt-3">
                    <v-btn
                      class="seeMore-btn"
                      @click="openSeeMoreModal('mehvar')"
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
                <div
                  v-else-if="
                    uniInfo.mehvars.length <= 4 && uniInfo.mehvars.length != 0
                  "
                >
                  <div
                    v-for="(mehvar, index) in uniInfo.mehvars"
                    :key="index"
                    class="mb-3"
                  >
                    <li class="fs-medium c-grey">
                      <v-icon>mdi-circle-medium</v-icon>
                      {{
                        mehvar.name.length > 70
                          ? mehvar.name.slice(0, 70) + "..."
                          : mehvar.name
                      }}
                    </li>
                  </div>
                  <div
                    class="text-left pt-3"
                    v-if="
                      showMehvarMoreBtn ||
                      uniInfo.otherMehvars.filter((x) => x.acceleratorId).length
                    "
                  >
                    <v-btn
                      class="seeMore-btn"
                      @click="
                        openSeeMoreModal('mehvar');
                        mehvarType = 'mehvars';
                      "
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
                <div
                  v-else-if="
                    !uniInfo.mehvars.length &&
                    uniInfo.otherMehvars.filter((x) => x.acceleratorId).length
                  "
                  class="ms-5"
                >
                  <ul>
                    <div
                      v-for="(mehvar, index) in uniInfo.otherMehvars.filter(
                        (x) => x.acceleratorId
                      )"
                      :key="index"
                      class="mb-3"
                    >
                      <li class="fs-medium c-grey">
                        <v-icon>mdi-circle-medium</v-icon>
                        {{
                          mehvar.name.length > 70
                            ? mehvar.name.slice(0, 70) + "..."
                            : mehvar.name
                        }}
                        <span
                          v-if="mehvar.acceleratorId"
                          @click="goToAccelerator(mehvar.acceleratorId)"
                          class="pointer cyan--text text--lighten-1"
                        >
                          {{
                            "( نام‌ شتاب‌دهنده: " +
                            mehvar.acceleratorName +
                            " )"
                          }}
                        </span>
                      </li>
                    </div>
                  </ul>

                  <div class="text-left pt-3">
                    <v-btn
                      v-if="showMehvarMoreBtn"
                      class="seeMore-btn"
                      @click="
                        openSeeMoreModal('mehvar');
                        mehvarType = 'otherMehvars';
                      "
                      text
                    >
                      <span class="c-primary">مشاهده بیشتر</span>
                    </v-btn>
                  </div>
                </div>
              </div> -->
            </v-card>
          </v-col>
        </v-row>
        <div v-if="uniInfo.isDistinguished" class="my-3">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="6" xl="6">
              <v-card class="common-card card-height">
                <v-row class="mb-4">
                  <v-col>
                    <h5 class="mt-1 c-dark fs-xxlarge">
                      پروژه‌های انجام شده دانشگاه
                    </h5>
                  </v-col>
                  <v-col cols="2" class="text-left">
                    <span @click="openEditModal('uniProjects')" class="pointer"
                      ><v-icon>$Edit</v-icon></span
                    >
                  </v-col>
                </v-row>
                <div v-if="uniInfo.uniProjects">
                  <div v-if="type != 'mobile'">
                    <p
                      class="c-grey fs-medium text-justify mb-0"
                      v-html="
                        uniInfo.uniProjects.length > 400
                          ? uniInfo.uniProjects.slice(0, 400) + '...'
                          : uniInfo.uniProjects
                      "
                    ></p>
                    <div
                      v-if="uniInfo.uniProjects.length > 400"
                      class="text-left pt-5"
                    >
                      <v-btn
                        class="seeMore-btn"
                        @click="openSeeMoreModal('uniProjects')"
                        text
                      >
                        <span class="c-primary">مشاهده بیشتر</span>
                      </v-btn>
                    </div>
                  </div>
                  <div v-if="type == 'mobile'">
                    <p
                      class="c-grey fs-medium text-justify mb-0"
                      v-html="
                        uniInfo.uniProjects.length > 200
                          ? uniInfo.uniProjects.slice(0, 200) + '...'
                          : uniInfo.uniProjects
                      "
                    ></p>
                    <div
                      v-if="uniInfo.uniProjects.length > 200"
                      class="text-left pt-5"
                    >
                      <v-btn
                        class="seeMore-btn"
                        @click="openSeeMoreModal('uniProjects')"
                        text
                      >
                        <span class="c-primary">مشاهده بیشتر</span>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="mt-2" v-else>
                  <hr />
                  <p class="c-grey fs-small text-center">
                    توضیحی برای این قسمت ثبت نشده است.
                  </p>
                  <hr />
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="6" xl="6">
              <v-card class="common-card card-height">
                <v-row class="mb-4">
                  <v-col>
                    <h5 class="mt-1 c-dark fs-xxlarge">
                      گرنت‌های دریافتی دانشگاه
                    </h5>
                  </v-col>
                  <v-col cols="2" class="text-left">
                    <span @click="openEditModal('uniGrants')" class="pointer"
                      ><v-icon>$Edit</v-icon></span
                    >
                  </v-col>
                </v-row>
                <div v-if="uniInfo.uniGrants">
                  <div v-if="type != 'mobile'">
                    <p
                      class="c-grey fs-medium text-justify mb-0"
                      v-html="
                        uniInfo.uniGrants.length > 400
                          ? uniInfo.uniGrants.slice(0, 400) + '...'
                          : uniInfo.uniGrants
                      "
                    ></p>
                    <div
                      v-if="uniInfo.uniGrants.length > 400"
                      class="text-left pt-5"
                    >
                      <v-btn
                        class="seeMore-btn"
                        @click="openSeeMoreModal('uniGrants')"
                        text
                      >
                        <span class="c-primary">مشاهده بیشتر</span>
                      </v-btn>
                    </div>
                  </div>
                  <div v-if="type == 'mobile'">
                    <p
                      class="c-grey fs-medium text-justify mb-0"
                      v-html="
                        uniInfo.uniGrants.length > 200
                          ? uniInfo.uniGrants.slice(0, 200) + '...'
                          : uniInfo.uniGrants
                      "
                    ></p>
                    <div
                      v-if="uniInfo.uniGrants.length > 200"
                      class="text-left pt-5"
                    >
                      <v-btn
                        class="seeMore-btn"
                        @click="openSeeMoreModal('uniGrants')"
                        text
                      >
                        <span class="c-primary">مشاهده بیشتر</span>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="mt-2" v-else>
                  <hr />
                  <p class="c-grey fs-small text-center">
                    توضیحی برای این قسمت ثبت نشده است.
                  </p>
                  <hr />
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card class="common-card card-height">
                <v-row class="mb-4">
                  <v-col>
                    <h5 class="mt-1 c-dark fs-xxlarge">توضیحات تکمیلی</h5>
                  </v-col>
                  <v-col cols="2" class="text-left">
                    <span
                      @click="openEditModal('uniFurtherDescription')"
                      class="pointer"
                      ><v-icon>$Edit</v-icon></span
                    >
                  </v-col>
                </v-row>
                <div v-if="uniInfo.uniFurtherDescription">
                  <div v-if="type != 'mobile'">
                    <p
                      class="c-grey fs-medium text-justify mb-0"
                      v-html="
                        uniInfo.uniFurtherDescription.length > 400
                          ? uniInfo.uniFurtherDescription.slice(0, 400) + '...'
                          : uniInfo.uniFurtherDescription
                      "
                    ></p>
                    <div
                      v-if="uniInfo.uniFurtherDescription.length > 400"
                      class="text-left pt-5"
                    >
                      <v-btn
                        class="seeMore-btn"
                        @click="openSeeMoreModal('uniFurtherDescription')"
                        text
                      >
                        <span class="c-primary">مشاهده بیشتر</span>
                      </v-btn>
                    </div>
                  </div>
                  <div v-if="type == 'mobile'">
                    <p
                      class="c-grey fs-medium text-justify mb-0"
                      v-html="
                        uniInfo.uniFurtherDescription.length > 200
                          ? uniInfo.uniFurtherDescription.slice(0, 200) + '...'
                          : uniInfo.uniFurtherDescription
                      "
                    ></p>
                    <div
                      v-if="uniInfo.uniFurtherDescription.length > 200"
                      class="text-left pt-5"
                    >
                      <v-btn
                        class="seeMore-btn"
                        @click="openSeeMoreModal('uniFurtherDescription')"
                        text
                      >
                        <span class="c-primary">مشاهده بیشتر</span>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="mt-2" v-else>
                  <hr />
                  <p class="c-grey fs-small text-center">
                    توضیحی برای این قسمت ثبت نشده است.
                  </p>
                  <hr />
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col>
            <v-card class="common-card w-100">
              <v-card-title>
                <v-row class="pb-5">
                  <v-col class="pa-0">
                    <h5 class="fs-xxlarge">گالری تصاویر</h5>
                  </v-col>
                  <v-col cols="3" class="text-left pa-0">
                    <span @click="goToImages()" class="pointer">
                      <v-icon class="mb-2">$Edit</v-icon>
                    </span>
                  </v-col>
                </v-row>
              </v-card-title>
              <div
                v-if="!uniInfo.gallery || !uniInfo.gallery.length"
                class="py-4 c-grey fs-small text-center"
              >
                <hr />
                تصویری برای این دانشگاه به ثبت نرسیده است.
                <hr />
              </div>
              <div v-else>
                <v-row v-if="type != 'mobile'">
                  <v-col
                    class="text-center img-col d-flex"
                    sm="4"
                    md="4"
                    lg="2"
                    xl="2"
                    v-for="(img, index) in uniInfo.gallery"
                    :key="index"
                  >
                    <img :src="img.url" class="gallery-img mb-2" />
                    <span class="fs-medium">{{
                      img.title.length > 20
                        ? img.title.slice(0, 20) + "..."
                        : img.title
                    }}</span>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-carousel
                    :show-arrows="uniInfo.gallery.length > 1"
                    v-model="model"
                    hide-delimiters
                  >
                    <v-carousel-item
                      cycle
                      v-for="(img, index) in uniInfo.gallery"
                      :key="index"
                      :src="img.url"
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                      class="slider"
                    >
                    </v-carousel-item>
                  </v-carousel>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-dialog v-model="seeMoreModal" width="600">
          <v-card v-if="seeMoreType == 'description'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xxlarge">{{ uniInfo.name }}</h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="seeMoreModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>

              <p
                class="c-grey fs-medium text-justify"
                style="line-height: 30px"
              >
                {{ uniInfo.description }}
              </p>
            </v-container>
          </v-card>
          <v-card v-else-if="seeMoreType == 'mehvar'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xxlarge">
                    موضوعات طرح تقسیم کار ملی
                  </h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="seeMoreModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div
                v-if="!uniInfo.cats.length"
                class="py-4 c-grey fs-small text-center"
              >
                <hr />
                موضوعی به ثبت نرسیده است.
                <hr />
              </div>
              <div v-else class="mehvars-box">
                <div
                  v-for="(cat, index) in uniInfo.cats"
                  :key="index"
                  class="mb-3"
                >
                  <span class="c-grey fs-medium">
                    <v-icon class="pt-4 c-grey">mdi-circle-medium</v-icon>
                    {{ " " + cat.name }}
                  </span>
                </div>
                <!-- <div
                  v-if="
                    uniInfo.otherMehvars.filter((x) => x.acceleratorId).length
                  "
                >
                  <hr />
                  <label class="c-dark fs-large">همکاری با شتاب‌دهنده‌ها</label>
                  <div class="mehvars-box">
                    <div
                      v-for="(mehvar, index) in uniInfo.otherMehvars.filter(
                        (x) => x.acceleratorId
                      )"
                      :key="index"
                      class="mb-5"
                    >
                      <span class="c-grey fs-medium">
                        <v-icon class="pt-3 c-grey">mdi-circle-medium</v-icon>
                        {{ " " + mehvar.name }}
                      </span>
                      <span
                        v-if="mehvar.acceleratorId"
                        @click="goToAccelerator(mehvar.acceleratorId)"
                        class="pointer cyan--text text--lighten-1"
                      >
                        {{
                          "( نام‌ شتاب‌دهنده: " + mehvar.acceleratorName + " )"
                        }}
                      </span>
                    </div>
                  </div>
                </div> -->
              </div>
            </v-container>
          </v-card>
          <v-card v-else-if="seeMoreType == 'uniProjects'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xxlarge">
                    پروژه‌های انجام شده دانشگاه
                  </h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="seeMoreModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <p
                class="c-grey fs-medium text-justify"
                style="line-height: 30px"
                v-html="uniInfo.uniProjects"
              ></p>
            </v-container>
          </v-card>
          <v-card v-else-if="seeMoreType == 'uniGrants'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xxlarge">
                    گرنت‌های دریافتی دانشگاه
                  </h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="seeMoreModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <p
                class="c-grey fs-medium text-justify"
                style="line-height: 30px"
                v-html="uniInfo.uniGrants"
              ></p>
            </v-container>
          </v-card>
          <v-card
            v-else-if="seeMoreType == 'uniFurtherDescription'"
            class="modal-card"
          >
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xxlarge">توضیحات تکمیلی</h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="seeMoreModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <p
                class="c-grey fs-medium text-justify"
                style="line-height: 30px"
                v-html="uniInfo.uniFurtherDescription"
              ></p>
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="editModal"
          :width="editType != 'logo' ? '650' : '450'"
        >
          <v-card v-if="editType == 'description'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xlarge">ویرایش توضیحات دانشگاه</h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="editModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div class="description-input">
                <v-textarea
                  outlined
                  rounded
                  no-resize
                  :loading="gettingInfo"
                  v-model="editInfo.description"
                ></v-textarea>
              </div>
              <div class="mt-3">
                <v-btn
                  @click="editDescription()"
                  color="#93329e"
                  class="c-light"
                  width="100"
                  height="42"
                  >تایید</v-btn
                >
              </div>
            </v-container>
          </v-card>
          <v-card v-else-if="editType == 'contact'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xlarge">ویرایش راه‌های ارتباطی</h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="editModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col>
                  <div class="disabled-fields">
                    <div class="label">استان</div>
                    {{ editInfo.state }}
                  </div>
                </v-col>
                <v-col>
                  <div class="disabled-fields">
                    <div class="label">شهر</div>
                    {{ editInfo.city ? editInfo.city : "-" }}
                  </div>
                </v-col>
              </v-row>
              <div class="textField-box">
                <v-text-field
                  label="نشانی دانشگاه"
                  outlined
                  rounded
                  :loading="gettingInfo"
                  v-model="editInfo.address"
                ></v-text-field>
                <v-text-field
                  label="تلفن‌های تماس روابط عمومی"
                  outlined
                  rounded
                  :loading="gettingInfo"
                  v-model="editInfo.tel"
                ></v-text-field>
                <v-text-field
                  label="کد پستی"
                  outlined
                  rounded
                  :loading="gettingInfo"
                  v-model="editInfo.postalCode"
                ></v-text-field>
                <v-text-field
                  label="آدرس تارنما"
                  outlined
                  rounded
                  :loading="gettingInfo"
                  v-model="editInfo.website"
                ></v-text-field>
              </div>
              <div
                v-if="checkUrl(editInfo.website)"
                class="red--text fs-xsmall mb-4"
                style="margin-top: -20px"
              >
                آدرس تارنما وارد شده صحیح نمی‌باشد.
              </div>
              <div class="mt-3">
                <v-btn
                  @click="editContact()"
                  color="#93329e"
                  class="c-light"
                  width="100"
                  height="42"
                  >تایید</v-btn
                >
              </div>
            </v-container>
          </v-card>
          <v-card v-else-if="editType == 'students'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-4">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xlarge">
                    ویرایش تعداد دانشجویان و اعضای هیئت علمی
                  </h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="editModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div class="textField-box">
                <v-text-field
                  label="تعداد دانشجویان مرتبط با زیست فناوری"
                  outlined
                  rounded
                  suffix="نفر"
                  type="number"
                  :loading="gettingInfo"
                  v-model="editInfo.bioStudentCounts"
                ></v-text-field>
              </div>
              <div class="textField-box">
                <v-text-field
                  label="تعداد کل دانشجویان"
                  outlined
                  rounded
                  suffix="نفر"
                  type="number"
                  :loading="gettingInfo"
                  v-model="editInfo.studentCounts"
                ></v-text-field>
              </div>
              <div class="textField-box">
                <v-text-field
                  label="اعضای هیئت مرتبط با زیست فناوری"
                  outlined
                  rounded
                  suffix="نفر"
                  type="number"
                  :loading="gettingInfo"
                  v-model="editInfo.bioScienceCommitteeCounts"
                ></v-text-field>
              </div>
              <div class="textField-box">
                <v-text-field
                  label="تعداد کل اعضای هیئت علمی"
                  outlined
                  rounded
                  suffix="نفر"
                  type="number"
                  :loading="gettingInfo"
                  v-model="editInfo.scienceCommitteeCounts"
                ></v-text-field>
              </div>
              <div class="mt-3">
                <v-btn
                  @click="editStudentTeacher()"
                  color="#93329e"
                  class="c-light"
                  width="100"
                  height="42"
                  >تایید</v-btn
                >
              </div>
            </v-container>
          </v-card>
          <v-card v-else-if="editType == 'logo'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xlarge">ویرایش لوگو دانشگاه</h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="editModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div
                v-if="!uploading"
                class="upload-box"
                @dragover="dragover"
                @dragleave="dragleave"
                @drop="drop"
              >
                <p class="c-grey fs-large mb-2">
                  فایل مورد نظر را به این قسمت بکشید
                </p>
                <p class="c-grey fs-large mb-2">یا</p>
                <v-btn
                  @click="$refs.upload.$refs.input.click()"
                  class="upload-btn"
                  height="42"
                  >یافتن فایل</v-btn
                >
              </div>
              <div v-else>
                <div class="d-flex flex-row w-100">
                  <div>
                    <v-icon class="mt-2" large>$File</v-icon>
                  </div>
                  <div class="w-100 px-3">
                    <p class="mb-0">در حال بارگذاری تصویر...</p>
                    <v-progress-linear
                      class="mt-1"
                      outlined
                      height="4"
                      :value="myFile.uploadPercentage"
                      color="#93329e"
                    >
                    </v-progress-linear>
                  </div>
                  <div class="c-purple pt-4">
                    {{ myFile.uploadPercentage }}%
                  </div>
                </div>
              </div>
            </v-container>
          </v-card>
          <v-card v-else-if="editType == 'uniProjects'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xlarge">
                    ویرایش پروژه‌های انجام شده دانشگاه
                  </h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="editModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div class="description-input">
                <vue-ckeditor
                  :loading="gettingInfo"
                  v-model="editInfo.uniProjects"
                  :config="config"
                />
              </div>
              <div class="mt-3">
                <v-btn
                  @click="editProjects()"
                  color="#93329e"
                  class="c-light"
                  width="100"
                  height="42"
                  >تایید</v-btn
                >
              </div>
            </v-container>
          </v-card>
          <v-card v-else-if="editType == 'uniGrants'" class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xlarge">
                    ویرایش گرنت‌های دریافتی دانشگاه
                  </h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="editModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div class="description-input">
                <vue-ckeditor
                  :loading="gettingInfo"
                  v-model="editInfo.uniGrants"
                  :config="config"
                />
              </div>
              <div class="mt-3">
                <v-btn
                  @click="editGrants()"
                  color="#93329e"
                  class="c-light"
                  width="100"
                  height="42"
                  >تایید</v-btn
                >
              </div>
            </v-container>
          </v-card>
          <v-card
            v-else-if="editType == 'uniFurtherDescription'"
            class="modal-card"
          >
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xlarge">توضیحات تکمیلی</h5>
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="editModal = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div class="description-input">
                <vue-ckeditor
                  :loading="gettingInfo"
                  v-model="editInfo.uniFurtherDescription"
                  :config="config"
                />
              </div>
              <div class="mt-3">
                <v-btn
                  @click="editFurtherDescription()"
                  color="#93329e"
                  class="c-light"
                  width="100"
                  height="42"
                  >تایید</v-btn
                >
              </div>
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showBigModal" width="580">
          <v-card class="modal-card">
            <v-container class="p-4">
              <div class="logo-image">
                <img
                  :src="
                    uniInfo.avatar
                      ? uniInfo.avatar
                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTasF2J01pp5zzTcs1-GtFdrelxnu331FtNs6jNP6LRwfLdIpw0zZEB7iOOf5NoPeKb_8g&usqp=CAU'
                  "
                />
              </div>
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog v-model="noEditModal" width="580">
          <v-card class="modal-card">
            <v-container class="p-4">
              <v-row>
                <v-col class="text-left">
                  <span @click="noEditModal = false" class="pointer">
                    <v-icon>$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div
                v-if="editType == 'name'"
                class="text-center fs-large c-dark pb-4"
              >
                نام دانشگاه قابل ویرایش نمی‌باشد.
              </div>
              <div v-else class="text-center fs-large c-dark pb-4">
                موضوعات طرح تقسیم کار ملی قابل ویرایش نمی‌باشند.
              </div>
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="isCatCompleteDialog"
          width="600"
          persistent
          scrollable
          attach="body"
          :retain-focus="false"
          :overlay="false"
        >
          <v-card class="modal-card">
            <v-container class="p-4">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <h5 class="mt-1 c-dark fs-xlarge text-justify">
                    "{{ uniInfo.name }}" به سامانه تقسیم کار ملی زیست فناوری خوش
                    آمدید. به منظور استفاده از خدمات سامانه در ابتدا نسبت به
                    تکمیل اطلاعات پژوهشی اقدام فرمایید.
                  </h5>
                </v-col>
              </v-row>

              <div class="mt-3">
                <v-btn
                  @click="goToCompleteCat()"
                  color="#93329e"
                  class="c-light"
                  height="42"
                  >تکمیل اطلاعات پژوهشی</v-btn
                >
              </div>
            </v-container>
          </v-card>
        </v-dialog>
        <v-file-input
          @change="myUpload(file)"
          v-model="file"
          ref="upload"
          outlined
          dense
          v-show="false"
        ></v-file-input>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Chart from "/src/components/charts/Chart.vue";
import validator from "validator";
import isURL from "validator/lib/isURL";
import VueCkeditor from "vue-ckeditor2";

export default {
  components: {
    Chart,
    isURL,
    validator,
    VueCkeditor,
  },
  data() {
    return {
      uploadedFiles: [],
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      city: "",
      model: 0,
      uniId: "",
      interval: {},
      busy: true,
      value: 0,
      uniInfo: {
        avatar: "",
        description: "",
        contactInfo: {
          address: "",
          phoneNumber: "",
          zipCode: "",
          url: "",
        },
        professorCount: "",
        scienceCommittee: [],
        bioTechStudentsNum: "",
        mehvars: [],
        dataBar: {},
        gallery: [],
      },
      list: [],
      noEditModal: false,
      loaded: false,
      scienceCommitteeSize: "",
      type: "",
      optionsBar: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: true,
            position: "right",
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            ticks: {
              beginAtZero: true,
              font: { family: "iransans" },
            },
            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      supportsChart: {},
      isBusy: false,
      vLoading: false,
      seeMoreModal: false,
      universityId: "",
      seeMoreType: "",
      editModal: false,
      editInfo: {},
      editType: "",
      gettingInfo: false,
      showBigModal: false,
      uploading: false,
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "Font",
          ],
        ],
      },
      mehvarType: "mehvars",
      pageLoaded: false,
      isCatComplete: false,
      isCatCompleteDialog: false,
    };
  },
  methods: {
    goToAccelerator(id) {
      let link = "";
      link = "/acceleratorProfile/" + id;
      window.open(link, "_blank");
    },
    checkWebsite() {
      if (
        this.uniInfo.website.indexOf("http://") == 0 ||
        this.uniInfo.website.indexOf("https://") == 0
      ) {
        return this.uniInfo.website;
      } else {
        return "//" + this.uniInfo.website;
      }
    },
    checkUrl(url) {
      if (this.editInfo.website) {
        if (validator.isURL(url)) {
          return false;
        } else {
          return true;
        }
      }
    },
    openNoEditDialog(type) {
      this.editType = type;
      this.noEditModal = true;
    },
    openSeeMoreModal(type) {
      this.seeMoreType = type;
      this.seeMoreModal = true;
    },
    openEditModal(type) {
      this.editType = type;
      // this.gettingInfo = true;
      this.update();
      if (type == "logo") {
        this.uploading = false;
        this.uploadedFiles = [];
        this.uploadPercentage = 0;
        this.isUploaded = false;
        this.file = [];
        this.myFile = new Object({
          uploadPercentage: 0,
        });
      }
      this.editInfo = JSON.parse(JSON.stringify(this.uniInfo));
      this.editModal = true;
    },
    addMehvar() {
      this.editInfo.mehvars.push("");
      setTimeout(() => {
        var container = document.querySelector(".edit-box");
        var scrollHeight = container.scrollHeight;
        container.scrollTop = scrollHeight;
      }, 100);
    },
    removeMehvar(index) {
      this.editInfo.mehvars.splice(index, 1);
    },
    goToMap() {
      this.$router.push("/map");
    },
    goToCompleteCat() {
      this.$router.push("/university/complete");
    },
    myUpload(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        this.uploading = true;

        // START UPLOAD PROCESS
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/university/profile/avatar", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.myFile.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((res) => {
            if (res.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.uniInfo.avatar = res.data;
              this.toast("لوگو با موفقیت ویرایش گردید.", "success");
              this.editModal = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.uploadedFiles = {};
            this.additionalFiles.contract = {};
            this.myFile.uploadPercentage = 0;
          });
      }
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      //   event.currentTarget.classList.remove("bg-gray-100");
      //   event.currentTarget.classList.add("bg-green-300");
      // }
    },
    dragleave() {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.file = event.dataTransfer.files;
      if (Array.from(this.file).length) {
        if (Array.from(this.file).length > 1) {
          this.toast(
            " در این بخش شما مجاز به آپلود بیش از یک عکس نمی‌باشید.",
            "error"
          );
          return;
        }
        Array.from(this.file).forEach((file) => {
          this.myUpload(file);
        });
      }
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    editDescription() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/editDescription",
          {
            description: this.editInfo.description,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.vLoading = false;
          this.editModal = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    editProjects() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/editUniProjects",
          {
            uniProjects: this.editInfo.uniProjects,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.vLoading = false;
          this.editModal = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    editGrants() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/editUniGrants",
          {
            uniGrants: this.editInfo.uniGrants,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.vLoading = false;
          this.editModal = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    editFurtherDescription() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/editUniFurtherDescription",
          {
            uniFurtherDescription: this.editInfo.uniFurtherDescription,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.vLoading = false;
          this.editModal = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    editContact() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/editContactUs",
          {
            address: this.editInfo.address,

            tel: this.editInfo.tel,

            website: this.editInfo.website,

            postalCode: this.editInfo.postalCode,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.vLoading = false;
          this.editModal = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    editStudentTeacher() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/editStudentTeacher",
          {
            scienceCommitteeCounts: this.editInfo.scienceCommitteeCounts,
            bioScienceCommitteeCounts: this.editInfo.bioScienceCommitteeCounts,
            studentCounts: this.editInfo.studentCounts,
            bioStudentCounts: this.editInfo.bioStudentCounts,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.vLoading = false;
          this.editModal = false;
          this.toast(res.data, "success");
          this.update();
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    getProfileInfo() {
      if (window.screen.width < 850) {
        this.type = "mobile";
      } else {
        if (document.body.clientWidth < 850) {
          this.type = "mobile";
        } else {
          this.type = "desktop";
        }
      }
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/dashboard",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.uniInfo = res.data;
          this.vLoading = false;
          this.gettingInfo = false;

          if (window.screen.width < 450 || document.body.clientWidth < 450) {
            this.optionsBar.plugins.legend.labels.font.size = "8";
            this.optionsBar.scales.x.ticks.font.size = "8";
            this.optionsBar.scales.y.ticks.font.size = "8";
          }
          setTimeout(() => {
            this.loaded = true;
            this.pageLoaded = true;
          }, 1000);
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.gettingInfo = false;
          this.vLoading = false;
        });
    },
    update() {
      if (window.screen.width < 850) {
        this.type = "mobile";
      } else {
        if (document.body.clientWidth < 850) {
          this.type = "mobile";
        } else {
          this.type = "desktop";
        }
      }
      this.$http
        .post(
          this.baseUrl + "/setad/university/profile/dashboard",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.uniInfo = res.data;
          this.vLoading = false;
          this.gettingInfo = false;

          if (window.screen.width < 450 || document.body.clientWidth < 450) {
            this.optionsBar.plugins.legend.labels.font.size = "8";
            this.optionsBar.scales.x.ticks.font.size = "8";
            this.optionsBar.scales.y.ticks.font.size = "8";
          }

          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.gettingInfo = false;
        });
    },
    goToImages() {
      this.$router.push("/university/images");
    },
  },
  computed: {
    computedMehvarCardTitle() {
      if (!this.uniInfo.otherMehvars.filter((x) => x.acceleratorId).length) {
        return "محورهای طرح تقسیم کار ملی";
      }
      // else if (
      //   this.uniInfo.otherMehvars.filter((x) => x.acceleratorId).length &&
      //   !this.uniInfo.mehvars.length
      // ) {
      //   return "محور‌های همکاری شده با شتاب‌دهنده";
      // }
      else {
        return "محورهای طرح تقسیم کار ملی";
      }
    },
    showMehvarMoreBtn() {
      let temp;
      temp = this.uniInfo[this.mehvarType].filter((x) => x.name.length > 70);
      if (temp.length) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (this.$route.fullPath == "/university/dashboard") this.getProfileInfo();
    this.isCatComplete = localStorage.getItem("isCatComplete");
    this.isCatComplete = this.isCatComplete == "false" ? false : true;
    this.isCatCompleteDialog = this.isCatComplete ? false : true;
  },
  watch: {
    $route(val) {
      if (val.fullPath == "/university/dashboard") this.getProfileInfo();
    },
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  .v-label {
    font-size: 0.9rem !important;
    color: #93329e !important;
    background-color: #fff;
    padding: 1px 10px;
    margin-bottom: 0 !important;
    height: 25px;
    transform: translateY(-31px);
  }
  .mehvars-box {
    margin: 5px 0;
    max-height: 450px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: #eee;
      opacity: 0.5;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      width: 10px;
      border-radius: 10px;
    }
  }
  .v-text-field__details {
    display: none !important;
  }
  .description-input {
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #93329e !important;
      padding-bottom: 15px !important;
      .v-text-field__slot {
        textarea {
          color: #656a81 !important;
          padding: 0 15px !important;
          &::-webkit-scrollbar {
            width: 8px;
          }

          &::-webkit-scrollbar-track {
            background-color: #eee;
            opacity: 0.5;
            border-radius: 10px;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #bdbdbd;
            width: 10px;
            border-radius: 10px;
          }
        }
      }
    }
  }
  .textField-box {
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #93329e !important;
    }
    .v-input__slot {
      min-height: 48px !important;
      margin-bottom: 25px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }

    label.v-label.v-label--active.theme--light {
      font-size: 0.9rem !important;
      color: #93329e !important;
      background-color: #fff;
      padding: 1px 10px;
      margin-bottom: 0 !important;
      height: 25px;
      transform: translateY(-31px);
    }
  }
  .edit-box {
    max-height: 400px;
    overflow-y: auto;
    padding: 10px 0 10px 15px;
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: #eee;
      opacity: 0.5;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      width: 10px;
      border-radius: 10px;
    }
  }
  .add-btn {
    border: 1px solid #93329e;
    background-color: rgba(154, 6, 128, 0.07) !important;
    box-shadow: none !important;
    border-radius: 6px !important;
    outline: none !important;
  }
  .v-icon {
    transform: translateY(-6px);
  }
  .upload-box {
    padding: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='9' ry='9' stroke='rgb(147, 50, 158)' stroke-width='2' stroke-dasharray='5' stroke-dashoffset='5' stroke-linecap='butt'/%3e%3c/svg%3e");
    .upload-btn {
      border: 1px solid #93329e;
      background-color: #fff;
      border-radius: 5px;
      font-size: 0.95rem;
      font-weight: bold;
      color: #93329e;
      box-shadow: none !important;
    }
  }
  .logo-image {
    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }
}

.transparent-card {
  background-color: transparent !important;
  box-shadow: none !important;
}

.gallery-img {
  width: 150px !important;
  height: 150px !important;
  border-radius: 5px;
}

.logo-box {
  width: 110px !important;
  height: 110px !important;
  margin-top: 5px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
}
</style>
